(function () {
  var root;
  var STEP = 2;
  var budget = 0;
  var allocation = { palestine: 0, cotedazur: 0, madagascar: 0 };

  function normalize(value) { return String(value || '').toLowerCase(); }
  function isSticker(item) {
    var type = normalize(item.product_type);
    var title = normalize(item.product_title || item.title);
    var handle = normalize(item.handle);
    return type.indexOf('autocollant') !== -1 || type.indexOf('sticker') !== -1 || title.indexOf('autocollant') !== -1 || title.indexOf('sticker') !== -1 || handle.indexOf('autocollant') !== -1 || handle.indexOf('sticker') !== -1;
  }
  function eligibleQuantity(cart) {
    return (cart.items || []).reduce(function (sum, item) { return sum + (isSticker(item) ? 0 : (Number(item.quantity) || 0)); }, 0);
  }
  function allocated() { return allocation.palestine + allocation.cotedazur + allocation.madagascar; }
  function euro(value) { return value + ' €'; }

  function render() {
    if (!root) return;
    var used = allocated();
    var remaining = Math.max(budget - used, 0);
    ['palestine','cotedazur','madagascar'].forEach(function (key) {
      var value = root.querySelector('[data-chm-value="' + key + '"]');
      var amount = root.querySelector('[data-chm-amount="' + key + '"]');
      var minus = root.querySelector('[data-chm-minus="' + key + '"]');
      var plus = root.querySelector('[data-chm-plus="' + key + '"]');
      if (value) value.textContent = euro(allocation[key]);
      if (amount) amount.textContent = euro(allocation[key]) + ' affecté';
      if (minus) minus.disabled = allocation[key] <= 0;
      if (plus) plus.disabled = budget <= 0 || used + STEP > budget;
    });
    var budgetEl = root.querySelector('[data-chm-budget-remaining]');
    var summary = root.querySelector('[data-chm-summary]');
    var submit = root.querySelector('.chm-cause-page__submit');
    if (budget <= 0) {
      if (budgetEl) budgetEl.textContent = '0 € à répartir';
      if (summary) summary.textContent = 'Votre panier ne contient actuellement aucun article éligible. Les autocollants ne génèrent pas de don.';
      if (submit) submit.disabled = true;
      return;
    }
    if (budgetEl) budgetEl.textContent = 'À répartir : ' + euro(remaining) + ' sur ' + euro(budget);
    if (summary) summary.textContent = remaining === 0 ? 'Votre répartition est complète. Vous pouvez continuer vers le paiement.' : 'Il reste ' + euro(remaining) + ' à répartir avant de continuer.';
    if (submit) submit.disabled = used !== budget;
  }

  function change(key, delta) {
    if (!Object.prototype.hasOwnProperty.call(allocation, key)) return;
    var next = allocation[key] + delta;
    if (next < 0) return;
    if (allocated() + delta > budget) return;
    allocation[key] = next;
    render();
  }

  function loadCart() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { if (!res.ok) throw new Error('Cart unavailable'); return res.json(); })
      .then(function (cart) { budget = eligibleQuantity(cart) * STEP; render(); })
      .catch(function () {
        var summary = root.querySelector('[data-chm-summary]');
        if (summary) summary.textContent = 'Impossible de calculer votre impact pour le moment. Revenez au panier puis réessayez.';
      });
  }

  function confirmSelection(button) {
    if (allocated() !== budget || budget <= 0) return;
    button.disabled = true;
    button.textContent = 'Enregistrement…';
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var attrs = Object.assign({}, cart.attributes || {});
        attrs['CHM — Don total'] = euro(budget);
        attrs['CHM — Palestine'] = euro(allocation.palestine);
        attrs['CHM — Côte d\'Azur Charité'] = euro(allocation.cotedazur);
        attrs['CHM — Madagascar'] = euro(allocation.madagascar);
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
      })
      .then(function (res) { if (!res.ok) throw new Error('Save failed'); return res.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Confirmer et payer';
        var summary = root.querySelector('[data-chm-summary]');
        if (summary) summary.textContent = 'La sélection n’a pas pu être enregistrée. Réessayez avant de payer.';
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    root = document.querySelector('[data-chm-cause-page]');
    if (!root) return;
    root.addEventListener('click', function (event) {
      var plus = event.target.closest('[data-chm-plus]');
      var minus = event.target.closest('[data-chm-minus]');
      var submit = event.target.closest('.chm-cause-page__submit');
      if (plus) change(plus.getAttribute('data-chm-plus'), STEP);
      if (minus) change(minus.getAttribute('data-chm-minus'), -STEP);
      if (submit) confirmSelection(submit);
    });
    loadCart();
  });
})();